/**
 * Cache mode
 * inspired by: https://javascript.info/fetch-api#cache
 */
export var CacheMode;
(function (CacheMode) {
    /**
     * use local cache if it is not expired, and load from network if it is no longer fresh
     */
    CacheMode[CacheMode["Default"] = 1] = "Default";
    /**
     * totally ignore cache, load from network and not store result to cache
     */
    CacheMode[CacheMode["NoStore"] = 2] = "NoStore";
    /**
     * load from network no matter there is local cache or not and store result to cache
     */
    CacheMode[CacheMode["NoCache"] = 3] = "NoCache";
    /**
     * use local cache if it exists, even it is expired, otherwise load from network and store result to cache
     */
    CacheMode[CacheMode["ForceCache"] = 4] = "ForceCache";
    /**
     * use local cache result, event it is expired.
     */
    CacheMode[CacheMode["OnlyIfCached"] = 5] = "OnlyIfCached";
    /**
     * use local cache if it is not expired, and load from network even it is fresh
     */
    CacheMode[CacheMode["ForceLoad"] = 6] = "ForceLoad";
})(CacheMode || (CacheMode = {}));
export var BackoffMode;
(function (BackoffMode) {
    /**
     * jittered exponential backoff
     */
    BackoffMode[BackoffMode["JitteredExponential"] = 1] = "JitteredExponential";
    /**
     * constant(None) backoff, use the same wait time constantly
     */
    BackoffMode[BackoffMode["Constant"] = 2] = "Constant";
    /**
     * exponential backoff, increase wait time by 2x for each retry
     */
    BackoffMode[BackoffMode["Exponential"] = 3] = "Exponential";
})(BackoffMode || (BackoffMode = {}));
